import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode  } from '@fortawesome/pro-solid-svg-icons'

import './QbInput.css'
import { mergeToNewObject } from '../../../util/helpers'
import { PASSWORD, TEXT } from '../../../constants/constants'
import QbInputDropdown from './QbInputDropdown/QbInputDropdown'

class QbInput extends Component {

  getCorrectType() {
    const { type } = this.props
    if (type === PASSWORD) {
      return PASSWORD
    }

    return type || TEXT
  }

  renderRequiredMessage() {
    const { errorMessage } = this.props
    if (errorMessage) {
      return (
        <div className={`qb-input-error-text ${getTextErrorClass(errorMessage)}`}>
          {errorMessage}
        </div>
      )
    }
    return null
  }

  renderSuccessMessage() {
    const { successMsg, success } = this.props

    if (success) {
      return (
        <div className={'qb-input-success-msg '} >
          {successMsg}
        </div>
      )
    }
    return null
  }

  renderQrButton() {
      const { qrButton } = this.props
      if (qrButton) {
          return (
            <QbQr onClick={this.props.handleShowQrReader}/>
          )
      }
      return null
  }

  getCorrectInputType() {
    const { errorMessage, onChange, value, eyePassword, inputStyle, textarea, sign, dpItems, onKeyDown } = this.props

    if (textarea) {
      return (
        <React.Fragment>
          <textarea
              style={mergeToNewObject(inputStyle, { overflow: 'auto', lineHeight: '20px' })}
              value={value}
              onChange={({target}) => onChange(target.value)}
              type={this.getCorrectType()}
              className={`qb-input-input qb-input-textarea ${getInputErrorClass(errorMessage)} ${getInputTypeClass(eyePassword)}`}
          />
          { this.renderQrButton() }
        </React.Fragment>
      )
    }

    return (
      <input
        onKeyDown={onKeyDown}
        style={inputStyle}
        value={value}
        onChange={({ target }) => onChange(target.value)}
        type={this.getCorrectType()}
        className={`qb-input-input ${getInputErrorClass(errorMessage)} ${getInputTypeClass(eyePassword || sign || dpItems)}`}
      />
    )
  }

  renderInputRightContent() {
    const { sign, dpItems, onSelectDpItem } = this.props
    if (sign) {
      return (
        <div className="qb-input-right-content qb-input-sign">
          <span className="">{sign}</span>
        </div>
      )
    }

    if (dpItems) {
      return <QbInputDropdown dpItems={dpItems} onSelectDpItem={onSelectDpItem} />
    }

    return null
  }

  render() {
    const { title, errorMessage, style } = this.props
    return (
      <div style={style} className={`qb-input-container ${getContainerErrorClass(errorMessage)}`}>
      <div style={{ display: 'flex', flexDirection: 'column-reverse' }}>
        {this.getCorrectInputType()}
        <label className="shared-label-text qb-input-label-text">{title}</label>
        { this.renderInputRightContent() }
      </div>
      { this.renderRequiredMessage() }
      { this.renderSuccessMessage() }
    </div>
    )
  }
}

export default QbInput

const QbQr = ({ onClick }) => (
    <span className="qb-input-right-content" onClick={onClick}>
    <FontAwesomeIcon style={FULL_WH_STYLE} icon={faQrcode} />
  </span>
)

const getContainerErrorClass = errorMessage => errorMessage ? 'qb-input-container--error' : ''

const getInputErrorClass = errorMessage => errorMessage ? 'qb-input-input--error' : ''

const getTextErrorClass = errorMessage => errorMessage ? 'qb-input-error-text--error' : ''

const getInputTypeClass = shouldAddPadding => shouldAddPadding ? 'qb-input-input--padding-right' : ''

const FULL_WH_STYLE = {height: '100%', width: '100%', color: '#2D2D2D'}


// WEBPACK FOOTER //
// ./src/components/shared/QbInput/QbInput.js